import { render, staticRenderFns } from "./NevronError.vue?vue&type=template&id=a037090a&scoped=true&"
import script from "./NevronError.vue?vue&type=script&lang=ts&"
export * from "./NevronError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a037090a",
  null
  
)

export default component.exports